import { EnumAgreementStatus } from 'api';
export const isAgreementStatusInactive = status => {
  switch (status) {
    case String(EnumAgreementStatus.Cancelled):
    case String(EnumAgreementStatus.Rejected):
    case String(EnumAgreementStatus.Inactive):
    case String(EnumAgreementStatus.Frozen):
    case String(EnumAgreementStatus.Terminated):
      return true;
    default:
      return false;
  }
};
export const isAgreementStatusEditable = status => {
  switch (status) {
    case String(EnumAgreementStatus.Cancelled):
    case String(EnumAgreementStatus.Rejected):
    case String(EnumAgreementStatus.Frozen):
    case String(EnumAgreementStatus.Terminated):
      return false;
    default:
      return true;
  }
};
export const isAgreementStatusClosed = status => {
  switch (status) {
    case String(EnumAgreementStatus.Cancelled):
    case String(EnumAgreementStatus.Rejected):
    case String(EnumAgreementStatus.Terminated):
      return true;
    default:
      return false;
  }
};